import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTheme } from '@mui/material';
import CreateNoticeTemplateDialog from '../components/CreateNoticeTemplateDialog';
import SortButton from './common/SortButton';
import NoticeTemplatesTable from './common/NoticeTemplatesTable';
import { SORT_CATEGORIES } from '../common/constants';
import { isVerticalIpadMini, isHorizontalIpadMini } from '../common/responsiveUtils';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '../images/delete_icon.svg';
import DeleteGrayIcon from '../images/delete_icon_gray.svg';

import TableContainer from '@mui/material/TableContainer';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';

const NoticeTemplate = () => {
  const { typography, palette } = useTheme();
  const [templates, setTemplates] = useState([]);
  const [selectedTemplateIds, setSelectedTemplateIds] = useState([]);
  const [openCreateTemplateDialog, setOpenCreateTemplateDialog] = useState(false);

  // テーブルの高さをPC, iPadMini(縦), iPadMini(横)で分ける
  let maxTableHeight = '430px';
  if (isVerticalIpadMini()) maxTableHeight = '630px';
  if (isHorizontalIpadMini()) maxTableHeight = '400px';
  const styles = {
    button: {
      ...typography.body14bold,
      height: '44px',
      backgroundColor: 'white',
      border: '1px solid ' + palette.primary.main,
    },
  };

  const fetchData = async () => {
    try {
      const { data } = await axios.get('/v1/notice-templates/');
      setTemplates(data);
    } catch (err) { }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDelete = async (selectedTemplateIds) => {
    try {
      await axios.delete('/v1/notice-templates', { data: { ids: selectedTemplateIds } });
      fetchData();
      setSelectedTemplateIds([]);
    } catch (err) { }
  };

  const changeDeleteIcon = (selectedTemplateIds) => {
    if (selectedTemplateIds.length === 0) {
      return DeleteGrayIcon;
    } else {
      return DeleteIcon;
    }
  };

  return (
    <>
      <Container>
        <Stack direction='row' justifyContent='flex-end' spacing={2} margin='16px 0px'>
          <Button variant="outlined"
            sx={styles.button}
            startIcon={
              <Avatar src={changeDeleteIcon(selectedTemplateIds)} alt='テンプレートを削除'
                sx={{ height: '24px', width: '24px' }} variant='square' />
            }
            onClick={() => handleDelete(selectedTemplateIds)}
            disabled={selectedTemplateIds.length === 0}
          >
            選択したテンプレートを削除
          </Button>
          <Button variant="outlined"
            sx={styles.button}
            startIcon={<AddIcon />}
            onClick={() => {
              setOpenCreateTemplateDialog(true);
            }}
          >
            通告テンプレート登録
          </Button>
        </Stack>
        <Stack marginBottom='9px'>
          <SortButton
            items={[
              SORT_CATEGORIES.SECTION_NUMBER_ASC,
              SORT_CATEGORIES.SECTION_NUMBER_DESC,
              SORT_CATEGORIES.NOTICE_CATEGORIES_ASC,
              SORT_CATEGORIES.NOTICE_CATEGORIES_DESC,
              SORT_CATEGORIES.CREATED_ASC,
              SORT_CATEGORIES.CREATED_DESC,
            ]}
            initialItem={SORT_CATEGORIES.CREATED_DESC}
            tableData={templates}
            setTableData={setTemplates}
          />
        </Stack>
        <TableContainer component={Paper} sx={{ maxHeight: maxTableHeight, overflowY: 'unset' }}>
          <NoticeTemplatesTable
            templates={templates}
            view='template'
            selectedTemplateIds={selectedTemplateIds}
            setSelectedTemplateIds={setSelectedTemplateIds}
          />
        </TableContainer>
      </Container>
      <CreateNoticeTemplateDialog
        open={openCreateTemplateDialog}
        setOpen={setOpenCreateTemplateDialog}
        templates={templates.concat()}
        setTemplates={setTemplates}
      />
    </>
  );
};

export default NoticeTemplate;
